export default "<footer class=\"block-footer\" [ngClass]=\"customClass\">\n  <ng-content></ng-content>\n</footer>\n"